import template from './check_attendance_report_help.html'
import * as Utils from '../../lib/savanna_utils.js'

class CheckAttendanceReportHelpViewModel
{
    constructor(dialog)
    {
        this.dialog = dialog;
    };

    close()
    {
        this.dialog.close();
    }
}

class CheckAttendanceReportHelpPage
{
    constructor(bindings)
    {
        this.viewModel = new CheckAttendanceReportHelpViewModel(this);
        this.bindings = bindings;
    }

    async init()
    {
        Utils.refresh_data_visible_roles()
    }
}

// Register the dialog
export default {
    name: 'CheckAttendanceReportHelp',
    dialog_class: CheckAttendanceReportHelpPage,
    template: template,
    template_filename: 'translation/dialogs/check_attendance_report_help',
    provider: 'ps'
}